module.exports = __webpack_public_path__ + "static/media/meet_anna_34.aa3596cb.png";